import { Bookmark, BookmarkBorder } from "@mui/icons-material";
import { IconButton } from "@mui/material";

function BookmarkButton({
  isBookmarked,
  disabled,
  onClick,
  stopPropagation = false,
  size = "small",
  jobTitle = "job",
  sx
}) {
  const label = isBookmarked ? `Remove ${jobTitle} from saved jobs` : `Save ${jobTitle}`;

  return (
    <IconButton
      size={size}
      aria-label={label}
      disabled={disabled}
      onClick={(event) => {
        if (stopPropagation) event.stopPropagation();
        onClick?.(event);
      }}
      sx={sx}
    >
      {isBookmarked ? <Bookmark /> : <BookmarkBorder />}
    </IconButton>
  );
}

export default BookmarkButton;
